module Meevo.Plugins.Product {
    import ProductUsageAmountTypeEnum = Meevo.Model.ProductUsageAmountTypeEnum;

    export class ProductInformationController {
        static $inject = [
            "$mdDialog",
            "meevo.components.common.DataService",
            "meevo.AppSettings", 
            "meevo.components.common.IdentityService",
            "meevo.components.busy.BusyService",
            "meevo.components.common.SecurityService",
            "options", 
            "$timeout",
            "$translate", 
            "meevoDateFilterFilter",
            "$mdBottomSheet",
            "$rootElement"
        ];
        public product : Meevo.Model.Product = null;
        public variant;
        public saleDataFetched: boolean;
        public fetchingData: boolean;
        public criteria;
        public activeTabIndex;
        public variantsDrilledInto : Meevo.Model.Variant[] = [];
        public salesDateRange: any;
        private holdScrollTop: number = 0;
        public selectedVariant: Meevo.Model.Variant;
        public showModelQuantityAndOrderPoint : boolean = false;
        public showSalesData : boolean = false;
        public salesButtonLabel : string;
        protected decimalPrecision: number;
        public tenantEnableProductUsageTracking: boolean = false;

        constructor(
            private $mdDialog: angular.material.IDialogService,
            public dataService: Meevo.Components.BaseClasses.IDataService,
            private appSettings: Meevo.Components.Common.IAppSettings,
            public identityService: Meevo.Components.Common.IIdentityService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private securityService: Meevo.Components.Common.ISecurityService,
            private options: ProductInfoModalOptions,
            public $timeout: angular.ITimeoutService,
            public $translate: ng.translate.ITranslateService,
            public meevoDateFilter: any,
            public $mdBottomSheet: angular.material.IBottomSheetService,
            public $rootElement: angular.IRootElementService) {
            

            this.decimalPrecision = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.inventoryDecimalPrecision || 4;
            this.tenantEnableProductUsageTracking = this.appSettings.APP_BUSINFOSETTINGS.generalSettings.productUsageTracking || false;

            console.log('PRODUCT INFO MODAL', this.options);
            
            this.criteria = this.getProductCriteria();
        }

        productCriteria = {
            coSearchResultFilter: 0,
            productObjectState: Meevo.Model.ObjectStateEnum.Active,
            variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
            includeNotForSale: true,
            explicitProductInventoryTypes: [Meevo.Model.ProductInventoryTypeEnum.Retail, Meevo.Model.ProductInventoryTypeEnum.ShopSupply, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply],
            productInventoryTypes: [Meevo.Model.ProductInventoryTypeEnum.Retail, Meevo.Model.ProductInventoryTypeEnum.ShopSupply, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply]
        }
        isFloorLocationsModuleAvailable(): boolean {
            return this.options.isInventoryFloorLocationModuleAvailable;
        }
        $onInit() { 
            if (this.qualifyForInventoryData()) {
                this.securityService.checkSecurityKey(`${Meevo.Components.Common.SecurityKeys.INVENTORY_PRODUCTMODAL_INVENTORYDATA}${Meevo.Components.Common.SecurityParts.KEY_PART_READ}`).then((data) => {
                    this.showModelQuantityAndOrderPoint = data == Meevo.Model.SecurityAccessEnum.Grant;
                }).finally(() => {
                    this.getProductDetails();
                });
            } else {
                this.getProductDetails();
            }
            if (this.qualifyForSalesData()) {
                this.securityService.checkSecurityKey(`${Meevo.Components.Common.SecurityKeys.INVENTORY_PRODUCTMODAL_SALESDATA}${Meevo.Components.Common.SecurityParts.KEY_PART_READ}`).then((data) => {
                    this.showSalesData = data == Meevo.Model.SecurityAccessEnum.Grant;
                    this.salesButtonLabel = this.showSalesData ? this.$translate.instant("LABEL_PRODUCT_SALES_AND_ACTIVITY_DATA") : this.$translate.instant("LABEL_PRODUCT_ACTIVITY_DATA");
                });
            }
        }

        qualifyForInventoryData() : boolean {
            return [ProductInfoModalParent.PurchaseOrder, 
                ProductInfoModalParent.Product,
                ProductInfoModalParent.EmployeeSupplyUsage,
                ProductInfoModalParent.InventoryReturns,
                ProductInfoModalParent.InventoryTransfer
            ].some(x => x == this.options.parentType)
        }

        showTypeAhead() : boolean {
            return this.options.parentType == ProductInfoModalParent.Convobar;
        }
        
        qualifyForSalesData() : boolean {
            return [ProductInfoModalParent.Product, 
                    ProductInfoModalParent.PurchaseOrder, 
                    ProductInfoModalParent.InventoryReturns,
                    ProductInfoModalParent.InventoryTransfer
                ].some(x => x == this.options.parentType);
        }
        
        showLastPoActivity() : boolean {
            return [ProductInfoModalParent.Register, 
                    ProductInfoModalParent.Convobar
                ].some(x => x == this.options.parentType);
        }

        showFloorLocations() : boolean {
            return [ProductInfoModalParent.InventoryCount
            ].some(x => x == this.options.parentType);
        }

        // based on inventoryCount.context logic in performSearch()
        getDecimalPrecision(item: any,onHand?:any): number {          
            return (this.isProductUsageEnabled(item) || this.hasPartial(onHand)) ? this.decimalPrecision : null;
        }
        isProductUsageEnabled(item: any): boolean {
            return this.tenantEnableProductUsageTracking && item && item.enableProductUsageTracking && item.productUsageType == ProductUsageAmountTypeEnum.PartialAmount;
        }
        hasPartial(item?: number): boolean {
            return !Number.isInteger(item);
        }


        getProductDetails() : void {
            if (this.options.productId || this.options.variantId) {
                this.fetchingData = true;
                this.dataService.getSectionById(this.appSettings.API_ENDPOINTS.productInfoModal, this.options.productId || this.options.variantId, this.getProductGetOptions())
                    .then((response) => {
                    this.product = response;
                        this.fetchingData = false;
                    if (!this.options.variantId && this.product.variants.length > 0) {
                        this.options.variantId = this.product.variants[0].id;
                        this.options.productInventoryTypeEnum = this.product.variants[0].productInventoryType;
                    } else if (this.options.variantId) {
                        this.product.variants = this.product.variants.filter(x => x.id == this.options.variantId && x.productInventoryType == this.options.productInventoryTypeEnum);
                        this.selectedVariant = this.product.variants[0];
                    }
                });
            }
        }

        getProductGetOptions() : string {
            var val = "?"
            if (this.showLastPoActivity()) {
                val += "includePurchaseOrderActivity=true";
            }
            // always need on hand values for U.S. 33322
            //if (this.qualifyForInventoryData()) {
            val += `${val.length > 1 ? "&" : ""}includeStockLevelConfig=true`;
            //}
            return val;
        }

        openSalesBottomSheet() : void {
            var __this = this;
            var dialog = $('#product-info-modal');
            dialog.scrollTop(0);

            this.$mdBottomSheet.show({
                templateUrl: 'app/plugins/product/modals/productSalesAndActivity.template.html',
                parent: this.$rootElement.find('#product-info-modal'),
                controller: "meevo.plugins.product.ProductSalesAndActivityController",
                controllerAs: "vm",
                locals: {
                    variantsDrilledInto: this.variantsDrilledInto,
                    variantId: this.options.variantId,
                    parentController: this
                }
              }).finally(() => {
                
                if (dialog) {
                    dialog.scrollTop(__this.holdScrollTop);
                    dialog.removeClass('overflow-hidden');
                    dialog.css("touch-action", "");
                }
              })
        }

        isMiscSupplyProduct(product: Meevo.Model.Product) : boolean {
            if (!product) return false;       
            return product.variants[0].productInventoryType == Meevo.Model.ProductInventoryTypeEnum.Other;
        }

        getVariantTypeDesc(variantType: Meevo.Model.VariantTypeEnum) : string {
            return Meevo.Model.VariantTypeEnum[variantType];
        }

        getVariantAttributeValue(variant, variantAttribute) : string {
            var item = variant.variantAttributes.filter(x => x.variantType == variantAttribute.variantType)[0];
            return item && item.displayName && item.displayName.length > 0 ? item.displayName[0] : '';
        }

        getSupplyCatgeoryDesc(supplyTypeEnum: Meevo.Model.SupplyCategoryEnum) : string {
            return this.$translate.instant(Meevo.Model.SUPPLY_CATEGORY_DESCRIPTION[supplyTypeEnum]) || Meevo.Model.SupplyCategoryEnum[supplyTypeEnum];
        }

        getSelectedProductInformation() {
            if (!this.variant) return;
            this.saleDataFetched = false;
            this.fetchingData = true;
            this.options.variantId = this.variant.id;
            this.product = null;
            if (this.variant.productId) {
                this.dataService.getSectionById(this.appSettings.API_ENDPOINTS.productInfoModal, this.variant.productId, this.getProductGetOptions())
                    .then((response) => {
                        this.product = response;
                        this.fetchingData = false;
                    });
            }
        }

        getProductCriteria() {
            if (this.identityService.inCentralOfficeMode()) {
                return this.productCriteria;
            }
            return {
                productObjectState: Meevo.Model.ObjectStateEnum.Active,
                variantObjectState: [Meevo.Model.ObjectStateEnum.Active, Meevo.Model.ObjectStateEnum.Inactive],
                includeNotForSale: true,
                explicitProductInventoryTypes: [Meevo.Model.ProductInventoryTypeEnum.Retail, Meevo.Model.ProductInventoryTypeEnum.ShopSupply, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply],
                productInventoryTypes: [Meevo.Model.ProductInventoryTypeEnum.Retail, Meevo.Model.ProductInventoryTypeEnum.ShopSupply, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply]
            };
        }

        isShopSupply(variant: Meevo.Model.Variant) : boolean {
            return variant.productInventoryType == Meevo.Model.ProductInventoryTypeEnum.ShopSupply;
        }

        isSelectedVariant(variant: Meevo.Model.Variant) : boolean {
            return this.qualifyForSalesData() && 
                variant.id == this.options.variantId && 
                variant.productInventoryType == this.options.productInventoryTypeEnum &&
                this.product.variants.length > 1 && 
                !this.saleDataFetched;
        }

        showLeftIndicator(variant: Meevo.Model.Variant) : boolean {
            return this.variantsDrilledInto.some(
                    x => x.id == variant.id 
                    && x.productInventoryType == variant.productInventoryType
                ) || (
                    variant.id == this.options.variantIdInitiator
                    && variant.productInventoryType == this.options.productInventoryTypeEnum
                );
        }

        getVariantSalesData(variant: Meevo.Model.Variant) : void {
            if (!this.qualifyForSalesData()) return;
            this.busyService.start();
            this.variantClicked(variant);
            this.loadSalesData();
            this.holdScrollTop = $('#product-info-modal').scrollTop();
        }

        loadSalesData() : void {
            this.fetchingData = true;
            if (!this.variantsDrilledInto.some(x => x.id == this.options.variantId && x.productInventoryType == this.options.productInventoryTypeEnum)) {
                
                var thisVariant = this.getVariant(this.options.variantId, this.options.productInventoryTypeEnum);
                var id = this.options.variantId;
                var salesDateRange = thisVariant.salesDateRange || 0;
                var salesStartDate;
                var salesEndDate;
                const dateFormat = 'YYYY-MM-DD'

                if (salesDateRange > 0) { 
                    var thisYear = moment(new Date(salesDateRange, 1, 1)).startOf('year');
                    salesStartDate = thisYear.format(dateFormat)
                    salesEndDate = thisYear.add(1, 'years').format(dateFormat)
                } else { // last 12 months
                    salesStartDate = moment().startOf('month').subtract(11, 'months').format(dateFormat);
                    salesEndDate = moment().format(dateFormat); // today
                    if (salesEndDate !== moment().endOf('month').format(dateFormat)) {
                        salesEndDate = moment().add(1, 'day').format(dateFormat); // used to get mid-day sales but not spill over to next month
                    }
                }
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/product/${id}/SalesAndActivity?startDate=${salesStartDate}&endDate=${salesEndDate}&productInventoryTypeEnum=${thisVariant.productInventoryType}&includeActivity=true&includeSales=${this.showSalesData}`, 'GET', null)
                    .then((response) => {
                        if (response && response.data) {
                            thisVariant.displayName = this.product.displayName;
                            if (response.data.sales) {
                                response.data.sales = response.data.sales.map(obj => {
                                    return {...obj, saleMonth : moment(obj.saleMonth).format("MMM")}
                                })};
                                thisVariant.sales[salesDateRange] = response.data.sales;
                            }
                            if (response.data.activity) {
                                thisVariant.activity = response.data.activity;
                            }
                            this.$timeout(() => {
                                this.variantsDrilledInto.push(thisVariant);
                                this.fetchingData = false;
                                this.saleDataFetched = true;                       
                            }, 1000);
                            this.$timeout(() => {
                                this.busyService.stop();
                                this.options.variantId = null;
                                this.openSalesBottomSheet();
                            }, 2000);
                            
                        }
                        
                    );
                
                
            }
            else {
                this.fetchingData = false;
                this.busyService.stop();
            }
        }

        getPoActivity(variant: Meevo.Model.Variant) : string {
            if (!variant.lastPurchaseOrderState || !variant.lastPurchaseOrderDate) return "N/A";
            
            var label;
            if (variant.lastPurchaseOrderState == Model.PurchaseOrderStateEnum.NotReceived) {
                label = this.$translate.instant("LABEL_ORDERED");
            } else {
                label = this.$translate.instant("ENUM_LABEL_" + variant.lastPurchaseOrderState);
            }
            return `${label} ${this.meevoDateFilter(variant.lastPurchaseOrderDate)}`;
        }

        variantClicked(variant: Meevo.Model.Variant) : void {
            if (!this.qualifyForSalesData()) return;
            
            this.options.variantId = variant.id;
            this.options.productInventoryTypeEnum = variant.productInventoryType;
            
            if (this.variantsDrilledInto.some(x => x.id == variant.id && x.productInventoryType == variant.productInventoryType)) {
                this.saleDataFetched = true;
                this.openSalesBottomSheet();
            } else {
                this.saleDataFetched = false;
            }
        }

        syncActiveTabIndex() : void {
            var matchId = this.options.variantId || this.product.variants[0].id;
            this.activeTabIndex = this.variantsDrilledInto.findIndex(x => x.id == matchId);
        }

        getVariant(id: string, productInventoryType: Meevo.Model.ProductInventoryTypeEnum) : Meevo.Model.Variant {
            var item = this.product.variants.filter(x => x.id == id && x.productInventoryType == productInventoryType);
            if (item.length > 0) {
                if (!item[0].sales) {
                    item[0].sales = {};
                }
                return item[0];
            }
            return null;
        }

        closeModal(e): void {
            if (e) e.stopPropagation();
            this.$mdDialog.hide();
        }

    }

    angular.module("meevo.plugins.product")
        .controller("meevo.plugins.product.ProductInformationController", ProductInformationController);
}